import axios from '../utils/axios';

export default function uploadBackgroundProcess(adminId, file, params) {
    return axios.post(`/admin/${adminId}/upload-background-process-csv`, file, { params });
}